<template>
  <Container type="card-full">
    <div class="view-container">
      <div class="view-box">
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目编号</div>
            <div class="view-value">{{project.projectcode}}</div>
          </div>
          <div class="view-field">
            <div class="view-label">平台编号</div>
            <div class="view-value">{{project.projectno}}</div>
          </div>
          <div class="view-field">
            <div class="view-label">采购人</div>
            <div class="view-value">{{project.pcomfullname}}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目名称</div>
            <div class="view-content">{{project.projectname}}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">评审方法</div>
            <div class="view-value">{{project.projectdoneflgdesc}}</div>
          </div>
          <div class="view-field">
            <div class="view-label">项目初审</div>
            <div class="view-value">{{+project.projectisqcheck === 1 ? '需要' : '不需要'}}</div>
          </div>
          <div class="view-field">
            <div class="view-label">价格分依据</div>
            <div class="view-value">{{project.projectpricecomputebasisdesc}}</div>
          </div>
        </div>

      </div>
    </div>
    <div class="split-line"></div>
  
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick" :before-leave="leaveTab">
      <el-tab-pane label="初审规则" name="scrule" v-if="+project.projectisqcheck === 1">
        <vggrid :random="Math.floor(Math.random() * 999999)"  :list="listsc" tableheight="600" flexname="" :cols="colssc"
                :showfooter="false" :showPage="false" :resizable="true"
                @cellClick="cellClick" @cellDblClick="view"
                :isOperate="+project.projectstatus === 10 ? isOperate : false" :operateBtn="operateBtnpqc" @vggridClick="vggridClick"
                :mergeRow='mergeRow'
        >
          <template slot="btn" v-if="showButton == 0">
            <vxe-button icon="vxe-icon--plus" status="perfect" @click="addpqc" :loading="btnLoading">新增</vxe-button>
            <vxe-button icon="vxe-icon--plus" status="perfect" @click="importTemplate" :loading="btnLoading">模板导入</vxe-button>
            <vxe-button icon="vxe-icon--plus" status="perfect" @click="importScoreExcel" :loading="btnLoading">Excel导入</vxe-button>
          </template>
        </vggrid>
      </el-tab-pane>
      <el-tab-pane label="总分设置" name="pfxm" v-if="+project.projectdoneflg ===3 || +project.projectdoneflg === 5">
        <project-set-total-scoring-form  :activeName="activeName" :projectid="$route.params.projectid"></project-set-total-scoring-form>
      </el-tab-pane>
      <el-tab-pane label="评审分设置" name="pfxm_ps" v-if="+project.projectdoneflg ===3 || +project.projectdoneflg === 5 ">
        <project-set-scoring-index :activeName="activeName"  pgname="评审"  :projectid="$route.params.projectid"></project-set-scoring-index>
      </el-tab-pane>
      <!-- <el-tab-pane label="技术分设置" name="pfxm_js" v-if="+project.projectdoneflg ===3">
        <project-set-scoring-index :activeName="activeName" pgname="技术" :projectid="$route.params.projectid"></project-set-scoring-index>
      </el-tab-pane> -->
      <el-tab-pane label="评审号生成" name="zjhcc" v-if="+project.projectdoneflg ===3 || +project.projectdoneflg === 5">
        <p-expert-create-index  :activeName="activeName"  :projectid="$route.params.projectid"></p-expert-create-index>
      </el-tab-pane>
    </el-tabs>
    <el-dialog :close-on-click-modal="false" :title="dialogTitle" :visible.sync="dialogVisible" width="600px"
               :modal-append-to-body="false">

      <div class="file">
        <div>
          <upload-btn @changed='importData' text="初审规则导入"></upload-btn>
        </div>
        <div class="excel">请点击下载
          <span @click="downloadfile">《初审规则导入模板.xlsx》</span>
        </div>

      </div>
    </el-dialog>
  </Container>
</template>
<script>
  import request from '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import PExpertCreateIndex from './pExpertCreateIndex'
  import ProjectSetScoringIndex from './projectSetScoringIndex'
  import ProjectSetTotalScoringForm from './projectSetTotalScoringForm'
  import utils from '../../assets/js/utils'
  import uploadBtn from '../common/uploadBtn.vue'

  export default {
    name: 'projectReviewRuleIndex',
    data () {
      return {
        dialogVisible: false,
        dialogType: 0,
        dialogTitle: '',
        project: {},
        activeName: 'scrule',
        isOperate: true,
        list: [],
        listsc: [],
        hackReset: false,
        btnLoading: false,
        radio: 1,
        cols: [
          {field: 'pgseq', fieldtype: 'I', title: '顺序', calculExpr: '', width: 80},
          {field: 'pgname', fieldtype: 'C', title: '名称', calculExpr: '', addNewRowFlg: false},
          {field: 'pgratio', fieldtype: 'F', title: '百分比', calculExpr: '', addNewRowFlg: false},
          {field: 'pgremark', fieldtype: 'C', title: '备注', calculExpr: '', addNewRowFlg: false}
        ],
        mergeRow:['ind','pqcitemchecktypedesc'],
        colssc: [
          {field: 'pqcitemseq', fieldtype: 'I', title: '顺序', calculExpr: '', width: 80},
          {field: 'pqcitemchecktypedesc', fieldtype: 'C', title: '初审类型', calculExpr: '', addNewRowFlg: false, width: 120},
          {field: 'pqcitemcheckcontent', fieldtype: 'C', title: '初审内容', calculExpr: '', addNewRowFlg: false},
          // {field: 'pqcitemcheckdemand', fieldtype: 'C', title: '初审要求', calculExpr: '', addNewRowFlg: false}
        ],
        pg: {},
        pqc: {},
        operateBtn: [
          {btncode: 'CHG', btnicon: 'el-icon-edit-outline', btnname: '修改'},
          {btncode: 'DEL', btnicon: 'el-icon-delete', btnname: '删除'}
        ],
        operateBtnpqc: [
          {btncode: 'CHGpqc', btnicon: 'el-icon-edit-outline', btnname: '修改'},
          {btncode: 'DELpqc', btnicon: 'el-icon-delete', btnname: '删除'}
        ],
        showButton: 1
      }
    },
    deactivated () {
      this.$destroy()
    },
    async created () {
      await this.getModel()
      if (this.$route.params.activeName) {
        this.activeName = this.$route.params.activeName
      }
      if (+this.project.projectisqcheck === 1) {
        this.activeName = 'scrule'
       await this.getpqcList()
      } else {
        this.activeName = 'pfxm'
      }
      // if (+this.project.projectdoneflg ===3) {
      //   this.activeName = 'zjhcc'
      // } else {
      //   this.activeName = 'scrule'
      // }
      this.$on('CHG', () => this.chgPg())
      this.$on('DEL', () => this.delPg())
      this.$on('CHGpqc', () => this.chgPqc())
      this.$on('DELpqc', () => this.delpqc())
    },
    async activated () {
      // this.getModel()
      // if (this.$route.params.activeName) {
      //   this.activeName = this.$route.params.activeName
      // }
      // if (+this.project.projectisqcheck === 1) {
      //   this.activeName = 'scrule'
      //   await this.getpqcList()
      // } else {
      //   this.activeName = 'pfxm'
      // }
    },
    mounted () {
    },
    async beforeRouteUpdate (to, from, next) {
    //   if (this.$route.params.activeName) {
    //     this.activeName = this.$route.params.activeName
    //   }
    //   await this.getModel()
    //   await this.getPageList()
    //   await this.getpqcList()
    },
    watch: {
    },
    components: {MenuBtn, vggrid, uploadBtn, PExpertCreateIndex, ProjectSetScoringIndex, ProjectSetTotalScoringForm},
    methods: {
      init(){
        // this.list = []
        // this.listsc= []
      },
      dialogClose () {
        this.dialogVisible = false
      },
      vggridClick (code, row) {
        this.pg = row
        this.pqc = row
        this.$emit(code, row)
      },
      async getModel () {
        let res = await request({
          method: 'get',
          url: '/xmgl/project/findProjectById',
          params: {projectid: this.$route.params.projectid}
        })
        this.project = res
        this.showButton = Number(this.project.projectstatus) === 10 ? 0 : 1
        if (+this.project.projectqcheckflg === 0) {
          this.showButton = 0
        }
      },
      async init () {
        this.list = []
        this.btnLoading = false
        this.pg = {}
      },
      async close () {
        let returnForm = 'projectIndex'
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: returnForm})
      },
      async addPg () {
        if (this.project.projectstatus !== '10' && +this.project.projectqcheckflg !== 0) {
          this.$message.error('项目公告已发布，不能新增评分项目！')
          return
        }
        let maxSeq = 0
        this.list.forEach(item => {
          if (item.pgseq > maxSeq) {
            maxSeq = item.pgseq
          }
        })
        maxSeq += 10
        let form = {
          pgid: 0,
          pgprojectid: this.project.projectid,
          project: this.project,
          pgseq: maxSeq,
          pgratiototal: this.total
        }
        this.$router.push({name: 'pgForm', params: {form: form, type: 1}})
      },
      async chgPg () {
        if (!this.project.projectid) {
          this.$message.warning('请选择一行!')
          return
        }
        if (this.project.projectstatus !== '10' && +this.project.projectqcheckflg !== 0) {
          this.$message.error('项目公告已发布，不能修改评分项目！')
          return
        }
        this.pg.project = this.project
        this.pg.pgratiototal = this.total - Number(this.pg.pgratio)
        this.$router.push({name: 'pgForm', params: {form: this.pg, type: 2}})
      },
      async delPg () {
        if (!this.project.projectid) {
          this.$message.warning('请选择一行!')
          return
        }
        if (this.project.projectstatus !== '10' && +this.project.projectqcheckflg !== 0) {
          this.$message.error('项目公告已发布，不能删除评分项目！')
          return
        }
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
          let data = await request({
            url: '/xmgl/project/delPg',
            method: "post",
            data: this.pg
          })
          if (data.issuccess === 1) {
            this.getPageList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error(data.msg)
          }
        })
      },
      async view () {
        this.pg.project = this.project
        this.pg.pgratiototal = this.total - Number(this.pg.pgratio)
        this.$router.push({name: 'pgForm', params: {form: this.pg, type: 3}})
      },
      async cellClick (row) {
        this.pg = row.row
      },
      handleClick (tab, event) {
        console.log(tab)
        if (tab.name === 'scrule') {
          this.getpqcList()
        }
        if (tab.name === 'pfxm') {
          // this.getPageList()
        }
      },
      async leaveTab(activeName, oldActiveName) {
        let res = await request({
          method: 'get',
          url: '/xmgl/pg/getPgParentList',
          params: {projectid: this.$route.params.projectid}
        })
        if((activeName==='pfxm_ps' || activeName==='pfxm_js') && !res.length) {
          return new Promise((resolve, reject)=> {
            this.$message.warning('请先设置总分！')
          })
        }
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getPgList',
          params: {projectid: this.project.projectid}
        })
        console.log(res)
        this.list = res
        this.loading = false
      },
      async getpqcList () {
        this.loading = true
        let from = {}
        from.pqcitemprojectid = this.project.projectid
        let res = await request({
          method: 'get',
          url: '/ywgl/qcm/getpqclist',
          params: from
        })
        this.listsc = res
        this.listsc.forEach(e => {
          // e.pqcitemchecktypeCN = e.pqcitemchecktype === 1 ? '资格性' : '符合性'
          e.ind = e.pqcitemchecktype === 1 ? '1' : '2'
        })
        // this.listsc.sort((a, b) => {
        //   return a.pqcitemchecktype - b.pqcitemchecktype
        // })
        this.loading = false
      },
      async addpqc () {
        if (this.project.projectstatus !== '10' && +this.project.projectqcheckflg !== 0) {
          this.$message.error('项目公告已发布，不能新增评分项目！')
          return
        }
        let form = {
          pqcitemid: 0,
          pqcitemprojectid: this.project.projectid
        }
        this.$router.push({name: 'pqcForm', params: {form: form, type: 1}})
      },
      async chgPqc () {
        this.$router.push({name: 'pqcForm', params: {form: this.pqc, type: 1}})
      },
      async delpqc () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
          let data = await request({
            url: '/ywgl/qcm/delpqc',
            method: "post",
            data: this.pqc
          })
          if (data.issuccess === 1) {
            this.getpqcList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error(data.msg)
          }
        })
      },
      async importTemplate () {
        let data = ''
        this.loading = true
        if (this.listsc.length) {
          this.$confirm(`已经存在条目，继续导入，将删除已经存在的条目!`, '提示', {
            confirmButtonText: '继续',
            cancelButtonText: '放弃',
            type: 'warning'
          }).then(async() => {
            data = await request({
              url: '/ywgl/qcm/importPqcFromQcm',
              method: "post",
              data: {projectid: this.project.projectid, delflag: 1}
            })
            if (data.issuccess === 1) {
              await this.getpqcList()
              this.$message.success('导入成功')
            } else {
              this.$message.error('导入失败')
            }
            this.loading = false
          }).catch(() => {
          })
        } else {
          data = await request({
            url: '/ywgl/qcm/importPqcFromQcm',
            method: "post",
            data: {projectid: this.project.projectid}
          })
          if (data.issuccess === 1) {
            await this.getpqcList()
            this.$message.success('导入成功')
          } else {
            this.$message.error('导入失败')
          }
          this.loading = false
        }
      },
      async importScoreExcel () {
        this.dialogVisible = true
      },
      downloadfile () {
        var tempwindow = window.open('_blank')
        tempwindow.location = this.excelPath
      },
      async importData (path, filename){
        let data = ''
        this.loading = true
        if (this.listsc.length) {
          this.$confirm(`已经存在条目，继续导入，将删除已经存在的条目!`, '提示', {
            confirmButtonText: '继续',
            cancelButtonText: '放弃',
            type: 'warning'
          }).then(async() => {
            data = await request({
              url: '/ywgl/qcm/importPqcFromExcel',
              method: "post",
              data: {projectid: this.project.projectid, delflag: 1, path: path.replace(this.$store.getters.uploadAddr, 'upload/')}
            })
            if (data) {
              this.$message.warning(data)
            } else {
              this.$message.success('数据导入成功')
              await this.getpqcList()
              this.dialogClose()
            }
          }).catch(() => {
          })
        } else {
          data = await request({
            url: '/ywgl/qcm/importPqcFromExcel',
            method: "post",
            data: {projectid: this.project.projectid, path: path.replace(this.$store.getters.uploadAddr, 'upload/')}
          })
          if (data) {
            this.$message.warning(data)
          } else {
            this.$message.success('数据导入成功')
            await this.getpqcList()
            this.dialogClose()
          }
        }
      }
    },
    filters: {},
    computed: {
      total () {
        return this.list && this.list.length ? this.list.map(t => Number(t.pgratio)).reduce((a, b) => a + b) : 0
      },
      excelPath () {
        return this.$store.getters.uploadAddr + 'upload/file/初审规则导入模板.xlsx'
      }
    }
  }
</script>
<style lang="scss" scoped>
  .file {
    display: flex;
    align-items: center;
    .excel {
      padding-left: 10px;
      span {
        color: #409EFF;
        cursor: pointer;
      }
    }
  }
</style>
